import { render, staticRenderFns } from "./JobAlertDetails.vue?vue&type=template&id=ca0df992&"
import script from "./JobAlertDetails.vue?vue&type=script&lang=js&"
export * from "./JobAlertDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports